// extracted by mini-css-extract-plugin
export default {"container":"SearchBarOptions_container__+l-4B","tab":"SearchBarOptions_tab__lCf6z"};